// Helpers for the vanilla schema v2 format:
//   - meta doc: native scalar fields
//   - slice docs: { data: "<JSON-stringified array>" }
//   - misc doc: object of JSON strings keyed by slice name
//
// Kept separate so the wire format can migrate without touching appstate.ts logic.

export function parseSlice<T>(data: unknown, fallback: T[] = []): T[] {
  if (typeof data !== 'string') return fallback
  try {
    const parsed = JSON.parse(data)
    return Array.isArray(parsed) ? parsed as T[] : fallback
  } catch {
    return fallback
  }
}

export function stringifySlice<T>(arr: T[]): string {
  return JSON.stringify(arr ?? [])
}
